import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {SessionModel} from "../../orchestration/session.model";
import {OrderingContextIntention} from "../../ordering-context/ordering-context";
import {Subscription} from "rxjs";
import {ResponsiveService} from "../../orchestration/responsive.service";
import {ButtonProminence, ButtonTier} from "../../buttons/button/button";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {SessionEvents} from "../../orchestration/session-events";
import {StoreData} from "../store-search.model";
import {OrderType} from "../../order/order";

@Component({
    selector: "woa-store-details-panel",
    templateUrl: "./store-details-panel.component.html"
})
export class StoreDetailsPanelComponent implements OnInit, OnDestroy {
    ButtonTier = ButtonTier;
    ButtonProminence = ButtonProminence;
    OrderType = OrderType;

    @Input() store: StoreData;
    @Input() intention: OrderingContextIntention;
    @Input() filteredOrderType: OrderType;
    @Input() summary: boolean = false;
    @Input() showStateWithName: boolean = false;
    @Input() showDistance: boolean = true;
    @Input() showStoreImage: boolean = false;
    @Input() showAddress: boolean = true;
    @Input() showDescription: boolean = true;
    @Input() collapseText: boolean = false;
    @Input() showTelephone: boolean = false;
    @Input() showMoreDetails: boolean = true;
    @Input() showStatus: boolean = true;
    @Input() showActions: boolean = true;
    @Input() showMap: boolean = false;

    @Output() onStoreDetails: EventEmitter<void> = new EventEmitter<void>();
    @Output() onOrderFromStore: EventEmitter<OrderType> = new EventEmitter<OrderType>();

    readonly TEXT_LINE_HEIGHT: number = 20;

    textCollapsed: boolean = true;
    submitted: boolean;

    private subscriptions: Subscription = new Subscription();

    constructor(public sessionModel: SessionModel,
                public responsiveService: ResponsiveService,
                private orderingContextModel: OrderingContextModel,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscriptions.add(SessionEvents.currentApp$.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get canShowDistance(): boolean {
        return this.showDistance && this.store && this.store.distance != undefined;
    }

    get canShowDescription(): boolean {
        return this.showDescription && !!this.store.description;
    }

    get canShowTelephone(): boolean {
        return this.showTelephone && this.store && !!this.store.telephone;
    }

    get canShowActions(): boolean {
        return this.showActions && this.intention !== OrderingContextIntention.VIEW_CURRENT_STORE;
    }

    get canShowOrderTypes(): boolean {
        return !this.filteredOrderType && !this.orderingContextModel.singleOrderType;
    }

    get canShowMap(): boolean {
        return this.showMap && this.store && ((!!this.store.latitude && !!this.store.longitude) || (!!this.store.locationImage.id && !!this.store.locationImage.image));
    }

    showStoreDetails(): void {
        this.onStoreDetails.emit();
    }

    orderHere(orderType?: OrderType): void {
        this.submitted = true;
        this.onOrderFromStore.emit(orderType ? orderType
            : this.canOrder(OrderType.ORDER_AHEAD) ? OrderType.ORDER_AHEAD
                : this.canOrder(OrderType.ORDER_DELIVERY) ? OrderType.ORDER_DELIVERY
                    : OrderType.ORDER_AT_TABLE);
    }

    canOrder(orderType: OrderType): boolean {
        return this.store && this.store.canOrder(orderType) && (this.filteredOrderType == undefined || this.filteredOrderType === orderType);
    }

    canCollapseText(text: HTMLElement): boolean {
        return this.collapseText && text.scrollHeight > this.TEXT_LINE_HEIGHT + 2;
    }

    toggleText(text: HTMLElement): void {
        if (this.canCollapseText(text)) {
            this.textCollapsed = !this.textCollapsed;
            text.style.maxHeight = (this.textCollapsed ? this.TEXT_LINE_HEIGHT : text.scrollHeight) + "px";
        }
    }

    getDirections(): void {
        if (!this.sessionModel.nativeMode) {
            // noinspection SpellCheckingInspection
            window.open("https://maps.apple.com/?daddr=" + this.store.latitude + "," + this.store.longitude, "_system", "noopener");
        }
    }

    callPhone(): void {
        if (!this.sessionModel.nativeMode) {
            window.open("tel:" + this.store.telephone, "_system");
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/store-details-panel/store-details-panel.component.ts